
export const toastStyles = {
  snackbar: {
    top: "20px",
    right: "20px",
    left: "auto",
    bottom: "auto",
  },
  alert: {
    minWidth: "320px",
    maxWidth: "500px",
  },
  alertTitle: (hasDescription) => ({
    fontWeight: 600,
    marginBottom: hasDescription ? "4px" : "0",
  }),
};

export const toastCSS = `
  /* Toast component positioning overrides for MUI Snackbar */
  .toast-snackbar,
  .MuiSnackbar-root.toast-snackbar,
  .MuiSnackbar-root.MuiSnackbar-anchorOriginTopRight,
  .MuiSnackbar-anchorOriginTopRight {
    top: 20px !important;
    right: 20px !important;
    left: auto !important;
    bottom: auto !important;
    transform: translateX(0) translateY(0) !important;
  }

  /* Ensure the snackbar container is positioned correctly */
  div[class*="MuiSnackbar-root"][class*="anchorOriginTopRight"],
  div[class*="MuiSnackbar-root"].toast-snackbar {
    top: 20px !important;
    right: 20px !important;
    left: auto !important;
  }
`;

